'use client';

import React, { useContext } from 'react';
import {
  PulseliveBroadcastersContext,
  PulseliveBroadcastersContextType,
  PulseliveContent,
  Broadcaster as PulseliveBroadcaster,
} from '@stadionhq-v3/pulselive-api';
import { Broadcasters } from '@stadionhq-v3/football-ui';
import classnames from 'classnames';
import { Broadcaster as ContentfulBroadcaster } from '@graphql/index';
import broadcastersTransform from '@utils/transforms/components/organisms/broadcasters.transform';
import { BroadcastersWrapperProps } from './broadcastersWrapper.types';
import styles from './broadcastersWrapper.module.scss';

const BroadcastersWrapper = ({
  fixtureId,
  broadcastersOverride,
  imageBaseUrl,
  imageExtension = 'png',
  locale,
}: BroadcastersWrapperProps) => {
  const classes = classnames([styles.broadcastersWrapper]);

  const { data: pulseliveBroadcastersData, isLoading } =
    useContext<PulseliveBroadcastersContextType>(PulseliveBroadcastersContext);

  const pulseliveFixture = pulseliveBroadcastersData?.content.find(
    (d: PulseliveContent) => d.fixture.altIds.opta === `g${fixtureId}`
  );

  const broadcasters =
    broadcastersOverride && broadcastersOverride.length > 0
      ? (broadcastersOverride as ContentfulBroadcaster[])
      : (pulseliveFixture?.broadcasters as PulseliveBroadcaster[]);

  if (!isLoading && !broadcasters) {
    return null;
  }

  return broadcasters?.length > 0 ? (
    <Broadcasters
      classNames={[classes]}
      broadcasters={broadcastersTransform(
        broadcasters,
        imageBaseUrl,
        imageExtension,
        locale
      )}
    />
  ) : null;
};

export default BroadcastersWrapper;
